<template>
  <div class="ask-show-answer">
    <van-nav-bar
    v-if="source==1&&pageLength>1"
    :title="info.question"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
     <van-nav-bar
    v-if="source==1&&pageLength==1"
    :title="info.question"
    :fixed="true"
    @click-left="onClickLeft">
    <template #left>
      <van-icon name="wap-home-o" size="18" />
    </template>
  </van-nav-bar>
    <div class="q-show" :style="{'margin-top':source==1?'50px':'0'}" v-if="info">
      <h1 v-if="info.question">
        <img class="quespic" :src="img.question" />
        {{ info.question }}
      </h1>
      <p>{{ info.content }}</p>
      <img class="img" v-for="(img, index) in info.image" :key="'img_' + index" v-lazy="img" />
      <div class="tag">
        <van-row type="flex" justify="space-between">
          <van-col span="18">
            <van-tag plain v-for="t in info.labels" :key="'label_' + t.id + '_id_' + info.id">{{ t.name }}</van-tag>
          </van-col>
          <van-col span="6" class="tip">
            <router-link class="c-blue" to="">我要回答</router-link>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="a-show" v-if="info && info.answers.length > 0">
      <div class="list-box" v-for="(item, index) in info.answers" :key="'list_' + item.id">
        <van-row type="flex" justify="space-between" v-if="item.user">
          <van-col span="4">
            <img class="listhand" :src="item.user.headimg_url ? item.user.headimg_url : img.avatar">
          </van-col>
          <van-col span="16">
            <div class="membername">
              {{item.user.user_name}}
            </div>
            <div class="sourtime">
              {{item.answer_time}}
            </div>
          </van-col>
          <van-col class="bintright" span="4">
            <!-- <van-button plain round>+关注</van-button> -->
          </van-col>
        </van-row>
        <div class="listitle ellipsis-2"></div>
        <router-link :to="{name: 'AskShowAnswer', params: {id: item.id}}" class="c-black">
          <van-row gutter="10" v-if="item.content.img">
            <van-col span="8">
              <img class="picone" v-lazy="item.content.img">
            </van-col>
            <van-col span="16" class="f-14 ellipsis-4">
              <img class="quespic" :src="img.answer">
              {{ item.content.text }}
            </van-col>
          </van-row>
          <div class="f-14 ellipsis-4" v-else>
            <img class="quespic" :src="img.answer">
            {{ item.content.text }}
          </div>
        </router-link>
        <div class="text-r">
          <router-link :to="{name: 'AskShowAnswer', params: {id: item.id}}" class="c-blue f-14">查看答案</router-link>
        </div>
        <van-row type="flex" justify="space-between">
          <van-col class="bintright" span="24">
            <span class="">
              <img class="binpic" :src="img.comment">
              <span class="sourtime">{{item.reply_num}}</span>
            </span>
            <span class="binbox">
              <img class="binpic" @click="setPraise(index)" :src="item.is_praise ? img.parise_have : img.parise">
              <span class="sourtime">{{item.praise_num}}</span>
            </span>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
  import ask from '../../../api/ask';
  import { mapState } from 'vuex';
  import {Row, Col, Tag, Button,NavBar,Icon} from "vant";

  export default {
    data () {
      return {
        params: {
          user_id: 0
        },
        question_id: 0,
        info: null,
        pageLength:1,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          comment: require('../../../assets/img/comment.png'),
          question: require('../../../assets/img/question.png'),
          answer: require('../../../assets/img/answers.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.pageLength=window.history.length
      if(this.source == 3||this.source ==7) {
        this.$appService.isShowReturn({state: true})
      }

      this.$store.commit('param/show', false)
      let id = this.$route.params.id
      if(this.$util.isEmpty(id)) {
        this.$toast('问题不存在')
        return false
      }
      this.question_id = id

      this.getInfo()
    },
    methods: {
      setPraise (index) {
        if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }else{
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }

        if(this.user) {
          let type = this.info.answers[index].is_praise ? 2 : 1;
          ask.setPraise({id: this.info.answers[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.info.answers[index].is_praise = 1
                this.info.answers[index].praise_num += 1
                // this.$toast.success('点赞成功')
              } else {
                this.info.answers[index].is_praise = 0
                this.info.answers[index].praise_num -= 1
                // this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      onClickLeft(){
        if(this.pageLength==1){
          this.$router.push({name:'Home'});
        }else{
          this.$router.go(-1)
        }
      },
      getInfo () {
        this.params.user_id = this.user ? this.user.id : 0

        ask.getShow(this.question_id, this.params).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            if(res.data.data.question){
              document.title = res.data.data.question;
              document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.question)
              document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.question)
            }
            
          }
        })
      }
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [Tag.name]: Tag,
      [Button.name]: Button,
      [NavBar.name]:NavBar,
    [Icon.name]:Icon,
    }
  };
</script>

<style lang="scss">
  .ask-show-answer {
    background-color: #F0F0F0;
    // .van-nav-bar__left {
  //  left: 10px;
  // }
    .img {
      width: 100%;
      margin-top: 10px;
      border-radius: 5px;
      display: block;
    }
    .quespic {
      width: 22px;
      height: 22px;
      vertical-align: middle;
    }
    .q-show {
      padding: 10px;
      overflow: hidden;
      background-color: #FFF;

      h1 {
        font-size: 16px;
      }
      p {
        margin: 0;
        font-size: 14px;
      }
      .van-tag {
        color: #3A3A3A;
        padding: 0 5px;
        margin-right: 5px;
      }
      .tip {
        text-align: right;

        .c-blue {
          font-size: 12px;
          color: #FFF;
          background: #33A1FF url(../../../assets/img/answer-button.png) no-repeat 8px center;
          background-size: 13px auto;
          width: 80px;
          height: 25px;
          line-height: 25px;
          display: inline-block;
          text-align: left;
          padding-left: 25px;
          border-radius: 12px;
          box-sizing: border-box;
        }
      }
      
    }
    .a-show {
      padding: 10px;
      margin-top: 10px;
      background-color: #FFF;

      .list-box {
        padding: 15px 10px;
        border-bottom: 1px solid #EAEAEA;

        .quespic{
          width: 22px;
          height: 22px;
          vertical-align: middle;
        }
        .picone{
          width:100%;
          height:105px;
          border-radius:5px;
          object-fit: cover;
        }
        .listitle{
          font-size: 16px;
          font-weight:bold;
          line-height: 32px;
          letter-spacing: 1.4px;
          margin: 10px 0;

          &.listitle2 {
            margin-top: 0;
          }
        }
        .sourtime{
          font-size: 12px;
          color: #9A9A9A;

          .c-blue {
            font-size: 12px;
            color: #FFF;
            background: #33A1FF url(../../../assets/img/answer-button.png) no-repeat 8px center;
            background-size: 13px auto;
            width: 80px;
            height: 25px;
            line-height: 25px;
            display: inline-block;
            text-align: left;
            padding-left: 25px;
            border-radius: 12px;
            box-sizing: border-box;
          }
        }
        .bintright{
          text-align:right;
          .binbox{
            margin-left:20px;
          }
          .binpic{
            width:15px;
            height:14px;
            margin-right:8px;
            vertical-align: middle;
          }
          .van-button--default {
            color: #F6AB00;
            border: 1px solid #F6AB00;
            width: 60px;
            height: 25px;
            line-height: 25px;
            font-size: 12px;
            padding: 0;
          }
        }
        .pic-box {

          .pic_thumb {
            border-radius: 5px;
            width: 100%;
            height: 225px;
            object-fit: cover;
            display: block;
          }
        }
        .listhand{
          width:45px;
          height:45px;
          border-radius:30px;
        }
        .membername{
          font-size: 15px;
          font-weight: bold;
        }
        .van-tag{
          padding: 0 5px;
          margin-right: 5px;
        }

      }
      
    }
  }
</style>
